import { yup } from '@tools/wr-catalog-base'

export const validationSchema = yup.object({
  company: yup.string().required('Customer name is a required field'),
})
